import React from "react";
import { InputText, MaterialIcon } from "@loanbossinc/component-library";
import DeleteIcon from "@material-ui/icons/Delete";
import { Close } from "@material-ui/icons";

import { determineFieldType, determineValueFormatting } from "../lineItemManagement";
import { FieldName, PropertyFieldWrapper, PropertyName, SelectedPropertyLeftWrapper, StyledFieldType } from "../styles";

import {
  SelectedFieldWrapper,
  SelectedFieldLeftSection,
  StyledIconButton,
  SelectedFieldInfo,
  FieldNameWrapper,
  FieldTypeWrapper,
  Card,
  StyledPropertySelectWrapper,
  StyledSelectButton,
  StyledCloseIconButton
} from "./styles";

const SinglePropertyFieldSelected = props => {
  const { handleSelect, cardIndex, selectedField, property } = props;

  return (
    <SelectedFieldWrapper>
      <SelectedFieldLeftSection>
        <StyledIconButton onClick={() => handleSelect(cardIndex, property?.propertyId)} disableRipple>
          <MaterialIcon style={{ color: "#005AA9", width: "18px" }} iconName="create" />
        </StyledIconButton>
        <SelectedFieldInfo>
          <FieldNameWrapper>{selectedField.name}</FieldNameWrapper>
          <FieldTypeWrapper>{determineFieldType(selectedField)}</FieldTypeWrapper>
        </SelectedFieldInfo>
      </SelectedFieldLeftSection>
      {determineValueFormatting(selectedField.type, selectedField.value)}
    </SelectedFieldWrapper>
  );
};

const MultiPropertyFieldNotSelected = props => {
  const { property, handleSelect, cardIndex } = props;

  return (
    <StyledPropertySelectWrapper>
      <PropertyName>{property && property.propertyName}</PropertyName>
      <StyledSelectButton id="select-property-btn" label="Select" w="120px" h="28px" onClick={() => handleSelect(cardIndex, property.propertyId)} />
    </StyledPropertySelectWrapper>
  );
};

const MultiPropertyFieldSelected = props => {
  const { property, handleSelect, cardIndex, multiplePropertiesComparisonFields, setNewLineItemSelections } = props;

  const onClearSelection = () => {
    const updatedFields = multiplePropertiesComparisonFields.map((group, idx) => {
      if (cardIndex === idx) {
        return group.map(prop => {
          if (prop.propertyId === property.propertyId) {
            return { ...prop, selectedField: null };
          }

          return prop;
        });
      }

      return group;
    });
    setNewLineItemSelections({ multiplePropertiesComparisonFields: updatedFields });
  };

  return (
    <StyledPropertySelectWrapper>
      <SelectedPropertyLeftWrapper style={{ alignItems: "center" }}>
        <StyledIconButton onClick={() => handleSelect(cardIndex, property?.propertyId)} disableRipple style={{ marginRight: "1em" }}>
          <MaterialIcon style={{ color: "#005AA9", width: "18px" }} iconName="create" />
        </StyledIconButton>
        <DeleteIcon style={{ cursor: "pointer", color: "#005AA9", marginRight: "1em" }} onClick={onClearSelection} />
        <PropertyFieldWrapper>
          <PropertyName multi>{property.propertyName}</PropertyName>
          <div>
            <FieldName>{property.selectedField.name}</FieldName>
            {" "}
            <StyledFieldType>{`(${determineFieldType(property.selectedField)})`}</StyledFieldType>
          </div>
        </PropertyFieldWrapper>
      </SelectedPropertyLeftWrapper>
      {determineValueFormatting(property.selectedField.type, property.selectedField.value)}
    </StyledPropertySelectWrapper>
  );
};

const SinglePropertyLineItems = props => {
  const { cardIndex, handleSelect, comparisonCard } = props;

  const isSelectedFieldToShow = () => {
    if (!comparisonCard?.selectedField) {
      return null;
    }

    return <SinglePropertyFieldSelected selectedField={comparisonCard.selectedField} handleSelect={handleSelect} cardIndex={cardIndex} />;
  };

  return (
    isSelectedFieldToShow() || (
      <StyledSelectButton
        label="Select"
        onClick={() => {
          handleSelect(cardIndex);
        }}
        h="32px"
        w="140px"
      />
    )
  );
};

const MultiPropertyLineItems = props => {
  const { comparisonCard, cardIndex, handleSelect } = props;

  return (
    comparisonCard && comparisonCard.map(property => (property.selectedField ? (
      <MultiPropertyFieldSelected key={property.propertyId} property={property} cardIndex={cardIndex} {...props} />
    ) : (
      <MultiPropertyFieldNotSelected key={property.propertyId} property={property} handleSelect={handleSelect} cardIndex={cardIndex} />
    )))
  );
};

const ComparisonFieldCard = props => {
  const { isMultipleProperties, cardIndex, handleChange, value, cardsAmount, onRemoveCard } = props;

  const minCardsAmount = 2;

  return (
    <Card idx={cardIndex}>
      <InputText
        variant="filled"
        id={`sub-line-item-name${cardIndex}`}
        name="sub-item-name"
        label="Sub-line item name"
        value={value}
        onChange={e => {
          handleChange(e, cardIndex);
        }}
        fullWidth
        style={{ marginBottom: "1em" }}
      />
      {isMultipleProperties ? <MultiPropertyLineItems {...props} /> : <SinglePropertyLineItems {...props} />}
      {cardsAmount > minCardsAmount && (
        <StyledCloseIconButton onClick={() => onRemoveCard(cardIndex)}>
          <Close style={{ color: "#C40A0A" }} />
        </StyledCloseIconButton>
      )}
    </Card>
  );
};

export default ComparisonFieldCard;
